// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-page-navigation {
  position: relative;
  width: 270px;
  height: 100%;
  background: #ffffff;
  border-right: 1px solid #d0d0d0;
  z-index: 10;
  transition: width 0.3s ease;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
}
.custom-page-navigation.collapsed {
  width: 48px;
}
.custom-page-navigation .page-nav-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
}
.custom-page-navigation .page-nav-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #fafafa;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.2s ease;
}
.custom-page-navigation .page-nav-header:hover {
  background: #f0f0f0;
}
.custom-page-navigation .page-nav-header i:first-child {
  color: #333;
  font-size: 0.9rem;
}
.custom-page-navigation .page-nav-header .page-nav-title {
  flex: 1 1;
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
}
.custom-page-navigation .page-nav-header .page-nav-collapse-arrow {
  color: #666;
  font-size: 0.85rem;
}
.custom-page-navigation .page-nav-collapsed {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0;
  cursor: pointer;
  background: #fafafa;
  transition: background 0.2s ease;
}
.custom-page-navigation .page-nav-collapsed:hover {
  background: #f0f0f0;
}
.custom-page-navigation .page-nav-collapsed .page-nav-expand-arrow {
  color: #666;
  font-size: 0.85rem;
  margin-bottom: 12px;
}
.custom-page-navigation .page-nav-collapsed .page-nav-vertical-text {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
  letter-spacing: 2px;
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-page-navigation .page-nav-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 0;
  background: #ffffff;
}
.custom-page-navigation .page-nav-list .page-nav-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.2s ease;
  border-bottom: 1px solid #f0f0f0;
}
.custom-page-navigation .page-nav-list .page-nav-item:hover {
  background: #f9f9f9;
}
.custom-page-navigation .page-nav-list .page-nav-item.active {
  background: #e8f4ff;
}
.custom-page-navigation .page-nav-list .page-nav-item.active .page-nav-item-text {
  color: #0078d4;
  font-weight: 600;
}
.custom-page-navigation .page-nav-list .page-nav-item.active .page-nav-check {
  color: #0078d4;
}
.custom-page-navigation .page-nav-list .page-nav-item .page-nav-item-text {
  flex: 1 1;
  font-size: 0.875rem;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.custom-page-navigation .page-nav-list .page-nav-item .page-nav-check {
  font-size: 0.875rem;
  margin-left: 8px;
}
.custom-page-navigation .page-nav-list::-webkit-scrollbar {
  width: 8px;
}
.custom-page-navigation .page-nav-list::-webkit-scrollbar-track {
  background: #fafafa;
}
.custom-page-navigation .page-nav-list::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  border-radius: 4px;
}
.custom-page-navigation .page-nav-list::-webkit-scrollbar-thumb:hover {
  background: #a0a0a0;
}

@media (max-width: 768px) {
  .custom-page-navigation {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/power-bi-portal/components/CustomPageNavigation.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;EACA,WAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,yCAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;AACJ;AAGE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gCAAA;AAFJ;AAII;EACE,mBAAA;AAFN;AAKI;EACE,WAAA;EACA,iBAAA;AAHN;AAMI;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAJN;AAOI;EACE,WAAA;EACA,kBAAA;AALN;AAUE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,gCAAA;AARJ;AAUI;EACE,mBAAA;AARN;AAWI;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;AATN;AAYI;EACE,yBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAVN;AAcE;EACE,SAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;AAZJ;AAcI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,gCAAA;AAZN;AAcM;EACE,mBAAA;AAZR;AAeM;EACE,mBAAA;AAbR;AAeQ;EACE,cAAA;EACA,gBAAA;AAbV;AAgBQ;EACE,cAAA;AAdV;AAkBM;EACE,SAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAhBR;AAmBM;EACE,mBAAA;EACA,gBAAA;AAjBR;AAuBE;EACE,UAAA;AArBJ;AAwBE;EACE,mBAAA;AAtBJ;AAyBE;EACE,mBAAA;EACA,kBAAA;AAvBJ;AAyBI;EACE,mBAAA;AAvBN;;AA6BA;EACE;IACE,wBAAA;EA1BF;AACF","sourcesContent":[".custom-page-navigation {\n  position: relative;\n  width: 270px;\n  height: 100%;\n  background: #ffffff;\n  border-right: 1px solid #d0d0d0;\n  z-index: 10;\n  transition: width 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);\n  flex-shrink: 0; // Don't shrink when in flex container\n\n  &.collapsed {\n    width: 48px;\n  }\n\n  // Expanded state - Full sidebar with pages\n  .page-nav-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    width: 100%;\n  }\n\n  .page-nav-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 16px;\n    background: #fafafa;\n    border-bottom: 1px solid #e0e0e0;\n    cursor: pointer;\n    user-select: none;\n    transition: background 0.2s ease;\n\n    &:hover {\n      background: #f0f0f0;\n    }\n\n    i:first-child {\n      color: #333;\n      font-size: 0.9rem;\n    }\n\n    .page-nav-title {\n      flex: 1;\n      font-size: 0.9rem;\n      font-weight: 600;\n      color: #333;\n    }\n\n    .page-nav-collapse-arrow {\n      color: #666;\n      font-size: 0.85rem;\n    }\n  }\n\n  // Collapsed state - Vertical text with arrow at top\n  .page-nav-collapsed {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 16px 0;\n    cursor: pointer;\n    background: #fafafa;\n    transition: background 0.2s ease;\n\n    &:hover {\n      background: #f0f0f0;\n    }\n\n    .page-nav-expand-arrow {\n      color: #666;\n      font-size: 0.85rem;\n      margin-bottom: 12px;\n    }\n\n    .page-nav-vertical-text {\n      writing-mode: vertical-rl;\n      text-orientation: mixed;\n      font-size: 0.9rem;\n      font-weight: 600;\n      color: #333;\n      letter-spacing: 2px;\n      flex: 1;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n\n  .page-nav-list {\n    flex: 1;\n    overflow-y: auto;\n    padding: 0;\n    background: #ffffff;\n\n    .page-nav-item {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 12px 16px;\n      cursor: pointer;\n      transition: background 0.2s ease;\n      border-bottom: 1px solid #f0f0f0;\n\n      &:hover {\n        background: #f9f9f9;\n      }\n\n      &.active {\n        background: #e8f4ff;\n\n        .page-nav-item-text {\n          color: #0078d4;\n          font-weight: 600;\n        }\n\n        .page-nav-check {\n          color: #0078d4;\n        }\n      }\n\n      .page-nav-item-text {\n        flex: 1;\n        font-size: 0.875rem;\n        color: #333;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .page-nav-check {\n        font-size: 0.875rem;\n        margin-left: 8px;\n      }\n    }\n  }\n\n  // Scrollbar styling\n  .page-nav-list::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  .page-nav-list::-webkit-scrollbar-track {\n    background: #fafafa;\n  }\n\n  .page-nav-list::-webkit-scrollbar-thumb {\n    background: #c0c0c0;\n    border-radius: 4px;\n\n    &:hover {\n      background: #a0a0a0;\n    }\n  }\n}\n\n// Hide on mobile - use the dropdown instead\n@media (max-width: 768px) {\n  .custom-page-navigation {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
